import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  showErrorMessage,
  showSuccessMessage,
  showWarningMessage,
} from '../utils/toast-functions';

/**
 * Custom hook that displays a success toast message from URL search params.
 * Looks for a 'showMessage' query parameter and displays it as a toast notification.
 */
export const useShowMessageToast = (): void => {
  const [searchParams] = useSearchParams();
  const showMessage = searchParams.get('showMessage');
  const messageType = searchParams.get('messageType');

  useEffect(() => {
    if (showMessage) {
      if (messageType) {
        if (messageType === 'success') {
          showSuccessMessage(showMessage);
        } else if (messageType === 'error') {
          showErrorMessage(showMessage);
        } else if (messageType === 'warning') {
          showWarningMessage(showMessage);
        }
      }
    }
  }, [showMessage]);
};
